module.exports = __webpack_public_path__ + "static/media/silverStar.9096cd03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/RequestTable/silverStar.svg
// module id = 157
// module chunks = 0